/*
 * @Author: liqiang70 liqiang70@58.com
 * @Date: 2025-05-14 16:05:40
 * @LastEditors: liqiang70 liqiang70@58.com
 * @LastEditTime: 2025-09-04 18:04:43
 * @Description: 
 */
import React, { useState } from 'react';
import { IMG_WOS } from '../../constants';
import "./index.scss";

// 车后服务数据
const ServiceList = [
    {
        title: "数字化车服生态体系",
        content: "为B/C端客户提供多样化、个性化的车服务产品，构建多层次/专业化/数字化的车服生态体系。",
        image: "https://fhlui1001.58wos.com.cn/cDazYxWcDHJ/picasso/onfqirsp__w840_h840.png"
    },
    {
        title: "创新服务产品",
        content: "主要以新能源车为主，包含动力电池衰减、修复、三电、电池故障维修等创新服务产品。",
        image: "https://fhlui1001.58wos.com.cn/cDazYxWcDHJ/picasso/d5mg67vk__w840_h840.png"
    },
    {
        title: "全方位服务方案",
        content: "58车服输出车后服务产品，为车主提供全方位优质服务与解决方案，搭建五八汽车服务平台。",
        image: "https://fhlui1001.58wos.com.cn/cDazYxWcDHJ/picasso/5jmqmf03__w840_h840.png"
    },
];

// 合作伙伴
const PartnerList = [
    {
        name: "太平洋保险",
        image: "https://fhlui1001.58wos.com.cn/cDazYxWcDHJ/picasso/e1t9p95p__w720_h264.png",
    },
    {
        name: "中国平安",
        image: "https://fhlui1001.58wos.com.cn/cDazYxWcDHJ/picasso/4adu6est__w720_h264.png",
    },
    {
        name: "中国大地保险",
        image: "https://fhlui1001.58wos.com.cn/cDazYxWcDHJ/picasso/8ap8rq4o__w720_h264.png",
    },
    {
        name: "壁虎科技",
        image: "https://fhlui1001.58wos.com.cn/cDazYxWcDHJ/picasso/ha8dv9kq__w720_h264.png",
    },
    {
        name: "特来电",
        image: "https://fhlui1001.58wos.com.cn/cDazYxWcDHJ/picasso/1a3ptcf6__w720_h264.png",
    },
    {
        name: "三星财产保险",
        image: "https://bxscht001.58wos.com.cn/UvSrQpOnUza/bxscwos/%E4%B8%89%E6%98%9F%E8%B4%A2%E9%99%A9logo.1782961051265.png",
    },
    {
        name: "创维汽车",
        image: "https://fhlui1001.58wos.com.cn/cDazYxWcDHJ/picasso/rpr7m7p5__w720_h264.png",
    },
    {
        name: "奇瑞",
        image: "https://fhlui1001.58wos.com.cn/cDazYxWcDHJ/picasso/g5a54i4g__w720_h264.png",
    },
    {
        name: "电动工坊",
        image: "https://fhlui1001.58wos.com.cn/cDazYxWcDHJ/picasso/3dv7h6hj__w720_h264.png",
    },
    {
        name: "金桔科技",
        image: "https://fhlui1001.58wos.com.cn/cDazYxWcDHJ/picasso/flco5ks7__w720_h264.png",
    },
    {
        name: "人人车",
        image: "https://fhlui1001.58wos.com.cn/cDazYxWcDHJ/picasso/fal8uoj1__w720_h264.png",
    },
    {
        name: "立保科技",
        image: "https://fhlui1001.58wos.com.cn/cDazYxWcDHJ/picasso/3sn0adef__w720_h264.png",
    },
    {
        name: "嘀嗒出行",
        image: "https://fhlui1001.58wos.com.cn/cDazYxWcDHJ/picasso/ei58frp0__w720_h264.png",
    },
    {
        name: "滴滴",
        image: "https://fhlui1001.58wos.com.cn/cDazYxWcDHJ/picasso/4mv2tn8s__w720_h264.png",
    },
    {
        name: "京东",
        image: "https://fhlui1001.58wos.com.cn/cDazYxWcDHJ/picasso/qvumpond__w720_h264.png",
    },
    {
        name: "车贝健",
        image: "https://fhlui1001.58wos.com.cn/cDazYxWcDHJ/picasso/qp87hgt5__w720_h264.png",
    },
];

const Index = () => {

    return (
        <div className="chefu-home">
            
            {/* banner */}
            <div className="chefu-home-banner">
                <div className="chefu-section-main">
                    <div className="chefu-home-banner-main">
                        <p className="chefu-home-banner-title">
                            一站式
                            <br />
                            汽车综合服务平台
                        </p>
                        <p>
                            58车服聚焦新能源汽车场景，利用聚合平台能力及人工智能服务，覆盖新能源维修网络，降低用户用车、修车服务成本，提升用户的用车体验。
                        </p>
                    </div>
                </div>
            </div>

            {/* 车后服务 */}
            <div className="chefu-home-service">
                <div className="chefu-section-main">
                    <div className="chefu-section-title">车后服务全生态</div>
                    <div className="chefu-section-subtitle">
                        58车服是58集团的车后服务业务版块，专注于涉车线上平台与线下多场景融合
                    </div>
                    <ul className="chefu-home-service-list">
                        {ServiceList.map((item, i) => (
                            <li
                                className="chefu-home-service-item"
                                key={`chefu-home-service-item${i}`}
                            >
                                <img
                                    src={item.image}
                                    alt={item.title}
                                    className="chefu-home-service-item-img"
                                />
                                <div className="chefu-home-service-item-title">
                                    {item.title}
                                </div>
                                <div className="chefu-home-service-item-content">
                                    {item.content}
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>

            {/* 合作伙伴 */}
            <div className="chefu-home-partner">
                <div className="chefu-section-main">
                    <div className="chefu-section-title">合作伙伴</div>
                    <ul className="chefu-home-partner-list">
                        {PartnerList.map((item, i) => (
                            <li
                                className={`chefu-home-partner-item${item.name === "三星财产保险" ? " chefu-home-partner-item--padding" : ""}`}
                                key={`chefu-home-partner-item${i}`}
                            >
                                <img src={item.image} alt={item.name} />
                            </li>
                        ))}
                    </ul>
                </div>
            </div>

            {/* 资质证书 */}
            <div className="chefu-home-qualification">
                <div className="chefu-home-qualification-main">
                    <div className="chefu-section-title">资质证书</div>
                    <div className="chefu-home-qualification-content">
                        <img
                            src={`${IMG_WOS}nljrtcc5__w4160_h1488.png`}
                            alt="资质证书"
                        />
                        <ul className="chefu-home-qualification-list">
                            <li className="chefu-home-qualification-item">
                                <p className="chefu-home-qualification-item-title">
                                    2024年12月
                                </p>
                                <p>选为中国汽车维修行业协会会员单位</p>
                            </li>
                            <li className="chefu-home-qualification-item">
                                <p className="chefu-home-qualification-item-title">
                                    2025年06月
                                </p>
                                <p>
                                    选为中国机电装备维修与改造技术协会会员单位
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Index;